import { render, staticRenderFns } from "./ClickCaptcha.vue?vue&type=template&id=d77c91b8&scoped=true&"
import script from "./ClickCaptcha.vue?vue&type=script&lang=js&"
export * from "./ClickCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77c91b8",
  null
  
)

export default component.exports